import type { CatalogIssue } from '@/api/plansService';

export const issueMessage = (issue: CatalogIssue, cycleName: string | undefined): string => {
  const cycle = cycleName ?? 'Cycle';
  const d = (issue.detail ?? {}) as Record<string, string | number | undefined>;
  switch (issue.code) {
    case 'PLAN_EMPTY':
      return 'Ajoutez au moins un cycle.';
    case 'CYCLE_MIN_ABOVE_RANKED':
      return `${cycle} : ${d.ranked} semaine(s) classée(s) pour le format ${d.format}, minimum ${d.min}.`;
    case 'CYCLE_NO_RANKED_WEEK':
      return `${cycle} : aucune semaine classée pour le format ${d.format}.`;
    case 'CAP_OUT_OF_BOUNDS':
      return `${cycle} : plafond hors des bornes du cycle.`;
    case 'FIXED_DAY_MISSING':
      return `${cycle} semaine ${issue.weekNumber} : jour manquant pour une séance (plan à jours fixes).`;
    case 'GENERIC_LENGTH':
      return `Un plan généraliste doit durer exactement 53 semaines : actuel ${d.weeks}.`;
    case 'RECOVERY_REQUIRED':
      return 'Un plan spécifique doit se terminer par au moins un cycle de rôle « Récupération ».';
    case 'RECOVERY_NOT_TRAILING':
      return 'Les cycles de récupération doivent être contigus et placés en dernier.';
    case 'RECOVERY_NOT_ALLOWED':
      return `${cycle} : un cycle de récupération n'a pas de sens sans course, retirez-le de ce plan.`;
    case 'TEST_CYCLE_CONTENT':
      return `${cycle} : un cycle de rôle « Tests » doit contenir au moins une séance de test.`;
    case 'THRESHOLD_ABOVE_DMIN':
      return `Préparation condensée : la durée minimale acceptée (${d.threshold} sem.) dépasse la durée minimale du plan (${d.dmin} sem.).`;
    case 'THRESHOLD_INVALID':
    case 'THRESHOLD_NOT_APPLICABLE':
      return 'Préparation condensée : valeur invalide pour ce plan.';
    case 'BRICK_OPTIONAL_FORBIDDEN':
      return `${cycle} semaine ${issue.weekNumber} : un enchaînement contient une séance de test ou de PPG.`;
    case 'TEST_SPORT_INVALID':
      return `${cycle} : une séance de PPG est marquée comme test ou comme déblocage.`;
    case 'OPENER_NOT_FIRST':
      return `${cycle} semaine ${issue.weekNumber} : une séance de déblocage doit être classée première de son sport.`;
    case 'OPENER_DUPLICATE_RANK':
      return `${cycle} semaine ${issue.weekNumber} : un test et un déblocage du même sport ne peuvent pas partager une semaine.`;
    case 'OPENER_NOT_ALLOWED':
      return `${cycle} semaine ${issue.weekNumber} : une séance de déblocage n'a de sens que dans un plan spécifique, qui a une compétition.`;
    case 'BRICK_IN_DAYS_ONLY':
      return `${cycle} : un plan « jours seuls » ne demande pas de jour d'enchaînement, retirez l'enchaînement.`;
    case 'TEST_DUPLICATE':
    case 'BRICK_DUPLICATE':
      return `${cycle} semaine ${issue.weekNumber} : incohérence tests / enchaînement, ouvrez le cycle pour corriger.`;
    case 'VOLUME_MISSING':
      return `Séances par semaine : renseignez ${d.sportId}.`;
    case 'VOLUME_INVALID':
      return `Séances par semaine (${d.sportId}) : il faut 0 ≤ min ≤ défaut ≤ max ≤ 7 et max ≥ 1.`;
    case 'VOLUME_ABSENT_SPORT':
      return `Séances par semaine : ${d.sportId} n'est plus dans le plan.`;
    default:
      return `${cycle} : incohérence dans les séances, ouvrez le cycle pour corriger.`;
  }
};
